/* global axios */
import ApiClient from '../ApiClient';

// The Meta page: what Meta says about every WhatsApp Cloud number, the
// notices log and the templates. Administrators only (server-enforced).
class TeletelMetaStatusAPI extends ApiClient {
  constructor() {
    super('meta-status', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  show() {
    return axios.get(this.url);
  }

  check() {
    return axios.post(`${this.url}/check`);
  }

  resolveNotice(id, resolved = true) {
    return axios.patch(`${this.url}/notices/${id}`, { resolved });
  }

  templates() {
    return axios.get(`${this.url}/templates`);
  }

  updatePrefs(prefs) {
    return axios.patch(`${this.url}/prefs`, { prefs });
  }

  createTemplate(template) {
    return axios.post(`${this.url}/templates`, template);
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/templates/sync`, { inbox_id: inboxId });
  }
}

export default new TeletelMetaStatusAPI();
